import React, { useContext, useMemo } from 'react';
import { ControlPreviewFactory } from './ControlPreviewFactory';
import { WizardContext } from './hooks/WizardContext';
import { useControlDrop } from './hooks/uiInteractions/useControlDrop';
import * as S from './styles/MobileObject.styles';

const MobileObject = ({ control, index, sectionId, dropIndicator, setDropIndicator }) => {
    const {
        selectedControlId,
        selectControl,
        activePage,
        moveControl
    } = useContext(WizardContext);

    const { ref, showIndicator } = useControlDrop({
        control,
        index,
        sectionId,
        dropIndicator,
        setDropIndicator,
        moveControl,
        activePageId: activePage.id
    });

    const styledControl = useMemo(() => {
        const isSeparator = control.factoryKey.includes('separator');
        return {
            ...control,
            top: 'auto',
            left: 'auto',
            width: '100%',
            height: isSeparator ? control.height : 'auto',
        };
    }, [control]);

    const isSelected = control.id === selectedControlId;

    return (
        <S.ItemWrapper
            ref={ref}
            control={control}
            showIndicator={showIndicator}
            onClick={(e) => {
                e.stopPropagation();
                selectControl(isSelected ? null : control.id);
            }}
        >
            <S.SelectionHighlight isSelected={isSelected} />
            <ControlPreviewFactory
                control={styledControl}
                renderMode="mobile"
                isSelected={isSelected}
                dragType="MOBILE_OBJECT"
                index={index}
                sectionId={sectionId}
                setDropIndicator={setDropIndicator}
            />
        </S.ItemWrapper>
    );
};

export default MobileObject;